<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} UTILISATEUR</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, initVal(), error_data =  []" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <vs-input autocomplete="off" class="mt-5 w-full" label="Nom"
                          :danger="error_data.last_name ? true : false"
                          :danger-text="error_data.last_name ? error_data.last_name[0] : ''"
                          v-model="last_name" placeholder="Nom" />

                <vs-input class="mt-5 w-full"
                          autocomplete="off"
                          label="Prénoms" v-model="first_name"
                          :danger="error_data.first_name ? true : false"
                          :danger-text="error_data.first_name ? error_data.first_name[0] : ''"
                          placeholder="Prénoms" />

                <vs-input class="mt-5 w-full"
                          :danger="error_data.email ? true : false"
                          :danger-text="error_data.email ? error_data.email[0] : ''"
                          label="Email" v-model="email"
                          placeholder="Email" />

                <vs-input class="mt-5 w-full"
                          autocomplete="off"
                          :danger="error_data.phone ? true : false"
                          :danger-text="error_data.phone ? error_data.phone[0] : ''"
                          label="Téléphone" v-model="phone"
                          placeholder="Téléphone" />

                <vs-select class="mt-5 w-full"
                           :danger="error_data.profile ? true : false"
                           :danger-text="error_data.profile ? error_data.profile[0] : ''"
                           v-model="profile" label="Profil" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in profiles" />
                </vs-select>

                <vs-input v-if="editEl == false" class="mt-5 w-full"
                          autocomplete="off"
                          type="password"
                          :danger="error_data.password ? true : false"
                          :danger-text="error_data.password ? error_data.password[0] : ''"
                          label="Mot de passe" v-model="password"
                          placeholder="Mot de passe" />
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="editEl === true ? updateInfo() : saveOrUpdate()" class="mr-6">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, initVal(), error_data =  []">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
            editEl: {
              type: Boolean
            },
            callBackAdd: {
              type: Function
            }
        },
        data() {
            return {
                dataId: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                profile: '',
                password: '',
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                error_data: [],
                profiles:[
                  {name: 'Selectionner', id: ''},
                  {name: 'Administrateur', id: '2'},
                  {name: 'Agent', id: '1'},
                ]
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            initValues() {
                if(this.data.id) return;
                this.dataId = '';
            },
            initVal(){
                this.dataId = ''
                this.first_name = '';
                this.last_name = '';
                this.email = '';
                this.phone = '';
                this.profile = '';
                this.password = '';
            },
            saveOrUpdate(){
              this.$vs.loading()
              this.$http.post('users/create', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone: this.phone,
                profile: this.profile,
                password: this.password
              }).then(() => {
                this.error_data = []
                this.$vs.loading.close()
                this.initVal()
                this.$emit('closeSidebar')
                this.$vs.notify({
                  time: 5000,
                  title: 'Succès!',
                  text: "Opération effectuée avec succès",
                  color: 'success',
                  iconPack: 'feather',
                  position: 'top-right',
                  icon: 'icon-check-circle'
                })
                this.callBackAdd()
              }).catch((error) => {
                this.$vs.loading.close()
                this.error_data = error.response.data.errors
              })
            },
            updateInfo(){
              this.$vs.loading()
              this.$http.post('users/update', {
                id: this.dataId,
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone: this.phone,
                profile: this.profile,
              }).then(() => {
                this.error_data = []
                this.$vs.loading.close()
                this.initVal()
                this.$emit('closeSidebar')
                this.$vs.notify({
                  time: 5000,
                  title: 'Succès!',
                  text: "Opération effectuée avec succès",
                  color: 'success',
                  iconPack: 'feather',
                  position: 'top-right',
                  icon: 'icon-check-circle'
                })
                this.callBackAdd()
              }).catch((error) => {
                this.$vs.loading.close()
                this.error_data = error.response.data.errors
              })
            }
        },
        watch: {
            isSidebarActive(val) {
                if(!val) return;
                if(Object.entries(this.data).length === 0) {
                    this.initValues()
                } else {
                    let { id, email, last_name, first_name, phone, profile } = JSON.parse(JSON.stringify(this.data));
                    this.dataId = id
                    this.first_name = first_name
                    this.last_name = last_name
                    this.email = email
                    this.phone = phone
                    this.profile = profile
                }
            },
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
    .vs-input-number {
        justify-content: space-around;
    }
</style>
